// =====================================================
// Formats partagés des taux (RUN 3) — module pur (pas de composant)
// =====================================================
// Extrait de RateDelta pour ne pas mêler helpers et composant (react-refresh).

/** Formatte une fraction (0..1, peut dépasser 1) en « 26,4 % ». null → « — ». */
export function fmtRate(value: number | null): string {
  if (value == null) return '—';
  return `${(value * 100).toLocaleString('fr-FR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })} %`;
}

/** Formatte un nombre de jours (« 19 j ») ou un ratio (« 3,2 »). null → « — ». */
export function fmtNumber(value: number | null, suffix = ''): string {
  if (value == null) return '—';
  return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 1 })}${suffix}`;
}
